





































import { GeeksSkillWithActivities, Season } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'ActivitiesTab',
  props: {
    activeSeason: Object as () => Season,
  },
  data() {
    return {
      loader: {
        isSkillListPending: true,
      },
    };
  },
  created() {
   if (this.activeSeason.id) {
     this.fetchActivities();
   }
  },
  computed: {
    skills(): GeeksSkillWithActivities[] {
      return typedStore(this).state.activities.geeksActivities;
    },
  },
  methods: {
    async fetchActivities() {
      await this.$store.dispatch(
        Actions.activities.fetchGeekActivities,
        { seasonId: this.activeSeason.id, geekId: this.$route.params.geekId },
      );
      this.loader.isSkillListPending = false;
    },
  },
  watch: {
    activeSeason: {
      async handler() {
        this.loader.isSkillListPending = true;
        this.fetchActivities();
      },
    },
  },
});
